















import Vue from "vue";
import { Timeline } from "vue-tweet-embed";

export default Vue.extend({
  name: "TwitterFeed",
  components: {
    Timeline
  },
  computed: {
    twitterHeight(): Record<string, string> {
      let calculatedHeight = "";
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          calculatedHeight = "90vh";
          break;
        case "sm":
          calculatedHeight = "80vh";
          break;
        case "md":
          calculatedHeight = "70vh";
          break;
        case "lg":
          calculatedHeight = "60vh";
          break;
        case "xl":
          calculatedHeight = "50vh";
          break;
      }
      return { height: calculatedHeight };
    }
  }
});
